import { forwardRef } from 'react';
import styled from 'styled-components';

import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';
import { useMeasure } from '@hivebrite/react-hooks';

const WrapperCard = forwardRef(({ children, ...otherProps }, ref) => (
  <Card px={0} py={0} ref={ref} {...otherProps}>
    {children}
  </Card>
));

const DonationsCardLoader = () => {
  const [ref, , { height, width }] = useMeasure();

  return (
    <WrapperCard height={304} ref={ref}>
      {width && height && (
        <>
          <SkeletonWrapper width={width} height="180px" />
          <Skeleton mx={6} mt={3} width={width - 48} height="24px" />
          <Skeleton mx={6} mt="6px" width="100px" height="17px" />
          <Skeleton mx={6} mt="7px" width={width - 48} height="34px" />
        </>
      )}
    </WrapperCard>
  );
};

export default DonationsCardLoader;

const SkeletonWrapper = styled(Skeleton)`
  border-top-left-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
  border-top-right-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
`;
